export const Role = Object.freeze({
    Customer: 'Customer',
    Employee: 'Employee',
    Manager: 'Manager',
    Admin: 'Admin',
    SuperAdmin: 'SuperAdmin',
    Owner: 'Owner',
});

export const RoleSign = Object.freeze({
    Employee: 'edg',
    Manager: 'mdg',
    Admin: 'adg',
    Owner: 'adg',
    SuperAdmin: 'sdg',
});

export const Scope = Object.freeze({
    Restaurant: 'Restaurant',
    Branch: 'Branch'
});

export const Gender = Object.freeze({
    Male: 'Male',
    Female: 'Female',
    NotSpecified: 'Not specified',
});

export const BranchType = Object.freeze({
    Main: "Main",
    Franchise: "Franchise",
    DeliveryHub: "Delivery Hub",
    Express: "Express Outlet",
    CloudKitchen: "Cloud Kitchen",
    Internal: "Internal"
});

export const InvestmentType = Object.freeze({
    Initial: 'Initial', // Initial capital to start restaurant or branch
    Monthly: 'Monthly', // Regular monthly contributions
    Emergency: 'Emergency', // Contributions during emergencies or unexpected expenses
    Asset: 'Asset', // Investment in physical assets like furniture, kitchen equipment
    Renovation: 'Renovation', // For remodeling or upgrading facilities
    Other: 'Other' // For other types of investments not covered by existing categories
});

export const StockScope = Object.freeze({
    Order: 'Order',
    Expense: 'Expense',
});

export const SpiceLevel = Object.freeze({
    Mild: 'Mild',
    Medium: 'Medium',
    Spicy: 'Spicy',
});

export const Size = Object.freeze({
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
});

export const PaymentType = Object.freeze({
    Cash: "Cash",
    Online: "Online",
    Credit: "Credit"
});

export const Status = Object.freeze({
    Active: "1",
    Inactive: "0",
    Archived: "-1",
});

export const IngredientUnits = Object.freeze({
    Kg: "kg",       // Kilogram
    G: "g",         // Gram
    Ltr: "ltr",     // Litre
    Ml: "ml",       // Millilitre
    Pcs: "pcs",     // Pieces
    Cup: "cup",     // Cup
    Tbsp: "tbsp",   // Tablespoon
    Tsp: "tsp",     // Teaspoon
    Dozen: "dozen", // Dozen (12 items)
    Packet: "packet"// Packet
});

export const SubscriptionStatus = Object.freeze({
    Active: "Active",
    Paused: "Paused",
    Cancelled: "Cancelled",
});

export const Frequency = Object.freeze({
    Daily: "Daily",
    Monthly: "Monthly",
    Weekly: "Weekly",
    Yearly: "Yearly",
});

export const OrderStatus = Object.freeze({
    // Pending: 0,
    // OutForDelivery: 1,
    // // Delivered: 2,
    // Completed: 3,
    // Cancelled: -1,
    Pending: 0,
    Accepted: 4,
    Preparing: 5,
    Ready: 6,
    OutForDelivery: 1,
    // Delivered: 2,
    Completed: 3,
    Cancelled: -1,
    Rejected: -2
});

export const OrderTrackStatus = Object.freeze({
    Pending: 0,
    Accepted: 4,
    Preparing: 5,
    Ready: 6,
    OutForDelivery: 1,
    // Delivered: 2,
    Completed: 3,
    Cancelled: -1,
    Rejected: -2
});

export const PaymentStatus = Object.freeze({
    Paid: 1,
    Pending: 0,
    Failed: -1
});

export const ServiceType = Object.freeze({
    DineIn: 'DineIn',
    TakeAway: 'TakeAway'
});

export const ProductType = Object.freeze({
    Prepared: 'Prepared',
    Packaged: 'Packaged',
    Raw: 'Raw'
});

export const DiscountType = Object.freeze({
    Percentage: 'Percentage',
    FixedAmount: 'Fixed Amount'
});

export const LocationType = Object.freeze({
    Point: 'Point'
});

export const ProductScope = Object.freeze({
    Order: "Order",
    InternalShare: "Internal Share",
    Vendor: "Vendor",
})

export const AppliedTo = Object.freeze({
    AllBranches: 1,
    Restaurant: 0,
});

export const FinancialSource = Object.freeze({
    Income: "Income",
    Expense: "Expense",
    Both: "Both",
    NotApplicable: "Not Applicable"
})

export const RecurringType = Object.freeze({
    IsFixed: "Is Fixed",
    Variable: "Variable"
})

export const GSTType = Object.freeze({
    "Gst-0%": 0,
    "Gst-5%": 5,
    "Gst-12%": 12,
    "Gst-18%": 18,
    "Gst-28%": 28,
})

